var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#86949D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2906 13.3091C13.1521 13.2508 12.9992 13.2356 12.8519 13.2653C12.7045 13.2949 12.5695 13.3682 12.4643 13.4756C12.3591 13.5829 12.2886 13.7194 12.2619 13.8673C12.2352 14.0152 12.2536 14.1677 12.3146 14.3051L15.4076 21.2501H22.9996C23.1986 21.2501 23.3893 21.3291 23.53 21.4698C23.6706 21.6104 23.7496 21.8012 23.7496 22.0001C23.7496 22.199 23.6706 22.3898 23.53 22.5304C23.3893 22.6711 23.1986 22.7501 22.9996 22.7501H15.4076L12.3146 29.6951C12.2536 29.8324 12.2352 29.985 12.2619 30.1329C12.2886 30.2808 12.3591 30.4173 12.4643 30.5246C12.5695 30.632 12.7045 30.7052 12.8519 30.7349C12.9992 30.7646 13.1521 30.7493 13.2906 30.6911L32.2906 22.6911C32.4265 22.6338 32.5425 22.5376 32.624 22.4147C32.7056 22.2918 32.7491 22.1476 32.7491 22.0001C32.7491 21.8526 32.7056 21.7084 32.624 21.5855C32.5425 21.4626 32.4265 21.3664 32.2906 21.3091L13.2906 13.3091Z",
    fill: "#86949D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendArrow);
export default __webpack_public_path__ + "static/media/send-arrow.f9744e7481f18b19c0ac6077e21aa9ce.svg";
export { ForwardRef as ReactComponent };